import { ca } from '@cian/analytics';

export function trackPrintAllClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'print_ads',
    category: 'ListingFavorites',
  });
}

export function trackDownloadExcelClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'export_ads',
    category: 'ListingFavorites',
  });
}
